import gql from "graphql-tag"

const fragment = gql`
  fragment MarketingProfileSettings on MarketingProfileSettings {
    emailSubscribed
    pushSubscribed
    unsubscribedEmail
    unsubscribedPush
    wellnessLiveNotifications {
      mediaId
      expiresAt
    }
  }
`

export default fragment
